module.exports = __webpack_public_path__ + "img/page6.d0e499f4.png";